import { apiUrl } from "./api";

/**
 * Says, once, that a part of the interface was used.
 *
 * Pins and lines travel through the socket, so the server can already count
 * those. Everything that happens only in the browser -- the floor buttons, the
 * satellite switch, the extract filter, the list, the pen's colours -- was
 * invisible, which meant a feature could go unused for a fortnight with nobody
 * the wiser, and a decision about what to build next had nothing to stand on.
 *
 * Deliberately coarse: **one line per feature per session**, never per press.
 * What is worth knowing is "did anyone reach for this today", and a press-by-
 * press stream would be a recording of somebody's evening rather than a count.
 * The server keeps its own list of names it will accept and drops the rest, so
 * nothing here can put free text in the log.
 *
 * Failures are silent on purpose. Nobody's map should break because a counter
 * could not be filed.
 */

const sent = new Set<string>();
let sessionId: string | null = null;

export function startUsage(session: string): void {
  sessionId = session;
  sent.clear();
}

export function used(feature: string): void {
  if (!sessionId || sent.has(feature)) return;
  sent.add(feature);
  void fetch(apiUrl("/api/usage"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session: sessionId, feature }),
    // Survives the tab closing right after the press that triggered it.
    keepalive: true,
  }).catch(() => {
    // A counter is not worth a retry, let alone an error on screen.
  });
}
